import { createGlobalStyle } from "styled-components/macro";
import reset from "styled-reset";

const GlobalStyle = createGlobalStyle`
  ${reset}
  
  html.scroll-snap {
    scroll-snap-type: y mandatory;
    
    .footer-wrapper {
      scroll-snap-align: start;
    }
  }
  
  html, body {
    background-color: ${({ theme }) => theme.background};
  }
  
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  body {
    font-family: "ObjectSans", -apple-system, system-ui;
  }
  
  body.ReactModal__Body--open {
    overflow: hidden;
  }

  input {
    font-family: -apple-system, system-ui;
    font-weight: 300;
  }

  input[type="text"] {
    -webkit-appearance: none;
  }

  input, button {
    background-color: transparent;
    border: none;
    outline: none;
  }

  button {
    font-family: -apple-system, system-ui;
    font-weight: 300;
    cursor: pointer;
    color: inherit;
    padding: 0;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
  }
  
  a {
    color: inherit;
    text-decoration: none;
  }

  i {
    font-style: italic;
  }
`;

export default GlobalStyle;
